export function TableHeader({ cols }: { cols: string[] }) {
	return (
		<div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
			{cols.map((c, i) => (
				<span
					key={c}
					style={{
						flex: i === 0 ? 2 : 1,
						fontSize: 11,
						fontWeight: 700,
						color: '#111',
						textAlign: i === 0 ? 'left' : 'right',
					}}
				>
					{c}
				</span>
			))}
		</div>
	);
}
